module.exports = __webpack_public_path__ + "img/logo.68727bd8.png";